"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _tslib = require("tslib");
var _react = _interopRequireDefault(require("react"));
var _reactFeather = require("react-feather");
var _reactDiv100vh = _interopRequireDefault(require("react-div-100vh"));
var _Elements = require("../../Elements");
var _Modules = require("../../Modules");
var _Layout = require("../../Layout");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Root = function Root(_a) {
  var _b = _a.variant,
    variant = _b === void 0 ? 'primary' : _b,
    props = (0, _tslib.__rest)(_a, ["variant"]);
  var isFullscreen = variant === 'fullscreen';
  return _react.default.createElement(_Layout.Box, (0, _tslib.__assign)({
    as: isFullscreen ? _reactDiv100vh.default : 'div',
    __themeKey: "modals",
    __css: {
      position: 'relative',
      backgroundColor: 'white',
      zIndex: '1001',
      maxWidth: isFullscreen ? '100%' : '600px',
      width: isFullscreen ? '100%' : ['100%', '75%'],
      mx: 'auto',
      my: isFullscreen ? '0' : [0, '5%'],
      pointerEvents: isFullscreen ? 'none' : ''
    },
    variant: variant + ".root"
  }, props));
};
var Header = function Header(_a) {
  var _b = _a.variant,
    variant = _b === void 0 ? 'primary' : _b,
    props = (0, _tslib.__rest)(_a, ["variant"]);
  return _react.default.createElement(_Layout.Flex, (0, _tslib.__assign)({
    __themeKey: "modals",
    __css: {
      justifyContent: 'space-between',
      px: 5,
      pt: 5,
      width: '100%'
    },
    variant: variant + ".header"
  }, props));
};
var Title = function Title(_a) {
  var _b = _a.variant,
    variant = _b === void 0 ? 'primary' : _b,
    props = (0, _tslib.__rest)(_a, ["variant"]);
  return _react.default.createElement(_Layout.Box, (0, _tslib.__assign)({
    __themeKey: "modals",
    variant: variant + ".title",
    __css: {
      as: 'h2',
      m: 0,
      fontSize: 6
    }
  }, props));
};
var Body = function Body(_a) {
  var _b = _a.variant,
    variant = _b === void 0 ? 'primary' : _b,
    props = (0, _tslib.__rest)(_a, ["variant"]);
  return _react.default.createElement(_Layout.Box, (0, _tslib.__assign)({
    __themeKey: "modals",
    variant: variant + ".body",
    __css: {
      p: 5
    }
  }, props));
};
var Modal = function Modal(_a) {
  var _b = _a.variant,
    variant = _b === void 0 ? 'primary' : _b,
    _c = _a.closeIcon,
    closeIcon = _c === void 0 ? true : _c,
    title = _a.title,
    children = _a.children,
    closeTitle = _a.closeTitle,
    closeOnClickOutside = _a.closeOnClickOutside,
    closeOnEsc = _a.closeOnEsc,
    className = _a.className,
    onClose = _a.onClose,
    isOpen = _a.isOpen,
    overlay = _a.overlay,
    lockBodyScroll = _a.lockBodyScroll,
    props = (0, _tslib.__rest)(_a, ["variant", "closeIcon", "title", "children", "closeTitle", "closeOnClickOutside", "closeOnEsc", "className", "onClose", "isOpen", "overlay", "lockBodyScroll"]);
  return _react.default.createElement(_Modules.Layer, {
    closeOnClickOutside: closeOnClickOutside,
    closeOnEsc: closeOnEsc,
    onClose: onClose,
    isOpen: isOpen,
    overlay: overlay,
    lockBodyScroll: lockBodyScroll
  }, _react.default.createElement(Root, (0, _tslib.__assign)({
    className: className,
    variant: variant
  }, props), title || closeIcon ? _react.default.createElement(Header, {
    variant: variant
  }, _react.default.createElement(Title, {
    variant: variant
  }, title), closeIcon && _react.default.createElement(_Elements.Link, {
    as: "button",
    color: "#959595",
    onClick: onClose,
    title: closeTitle
  }, _react.default.createElement(_reactFeather.XCircle, null))) : null, _react.default.createElement(Body, {
    variant: variant
  }, children)));
};
var _default = Modal;
exports.default = _default;